import * as React from 'react';
import clx from 'classnames';
import './ProcedureTableCellRecipient.scss';
import { ProcedureRecipientIcon } from 'client/components/schema/procedures/recipient/ProcedureRecipientIcon';
import { Tooltip } from 'antd';
import { ProcedureRecipientTitle } from '../recipient/ProcedureRecipientTitle';
import { ProcedureRecipient } from 'common/schema/Procedure';
import { useConfigRecipientEnabled } from '../hooks/useConfigRecipientEnabled';

export interface ProcedureTableCellRecipientProps {
  recipient: ProcedureRecipient;
}

export function ProcedureTableCellRecipient(
  props: ProcedureTableCellRecipientProps
) {
  const recipientEnabled = useConfigRecipientEnabled();

  return (
    <span
      className={clx(
        'procedure-table-cell-recipient',
        props.recipient.toLowerCase()
      )}
    >
      {recipientEnabled ? (
        <Tooltip
          arrowPointAtCenter
          placement="topLeft"
          title={<ProcedureRecipientTitle recipient={props.recipient} />}
        >
          <span className="tooltip-activator">
            <ProcedureRecipientIcon recipient={props.recipient} />
          </span>
        </Tooltip>
      ) : (
        <ProcedureRecipientIcon recipient={props.recipient} />
      )}
    </span>
  );
}
